import React, { useState } from "react"
import { Alert, Badge, CircularProgress, IconButton, Snackbar, Tooltip } from "@mui/material"
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined"
import { buildDocumentsZip, downloadDocument, saveBlob } from "../../utils/downloadDocuments"

export default function DescargarDocumentos({ carro }) {
  const files = carro.archivos || []
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState("")
  const download = async event => {
    event.stopPropagation()
    if (busy || !files.length) return
    setBusy(true)
    try {
      if (files.length === 1) await downloadDocument(files[0])
      else saveBlob(await buildDocumentsZip(files), `Documentos-${(carro.economico || carro.idCarro).toString().replace(/[^\w-]/g, "_")}.zip`)
    } catch (e) { setError(e.message || "No se pudieron descargar los documentos.") }
    finally { setBusy(false) }
  }
  return <>
    <Tooltip title={!files.length ? "Sin documentos adjuntos" : files.length === 1 ? "Descargar documento" : `Descargar ${files.length} documentos en ZIP`}>
      <span><IconButton aria-label={`Descargar documentos de ${carro.economico}`} disabled={busy || !files.length} onClick={download}
        sx={{ color: "#157cc1", borderRadius: 2, bgcolor: files.length ? "#e8f3fb" : "transparent" }}>
        {busy ? <CircularProgress size={22} /> : <Badge badgeContent={files.length} color="primary" max={99}><FileDownloadOutlinedIcon /></Badge>}
      </IconButton></span>
    </Tooltip>
    <Snackbar open={!!error} autoHideDuration={8000} onClose={() => setError("")}>
      <Alert severity="error" onClose={() => setError("")}>{error}</Alert>
    </Snackbar>
  </>
}
